import {Callbacks, Directory, Member} from './directory.js';

type MemberInfo = {
    member: Member;
    memberId: number,
    callbacks?: Callbacks;
}

class StaticDirectory implements Directory {
    private readonly members: Map<string, MemberInfo>;
    constructor(members: Map<string, MemberInfo>) {
        this.members = members;
    }

    add(nodeId: string, endpointUri: string, callbacks: Callbacks) {
        if (this.members.has(nodeId)) {
            this.members.get(nodeId)!.callbacks = callbacks;
            const connectCallback = callbacks.connect;
            const memberId = this.members.get(nodeId)!.memberId;
            if (connectCallback) {
                Array.from(this.members.values())
                    .filter((e) => e.memberId < memberId)
                    .forEach((e) => {
                        connectCallback({cmd: 'connect', node: nodeId, to: e.member});
                    });
            }
        }
    }
    remove(nodeId: string) {
        if (this.members.has(nodeId)) {
            const removed = this.members.get(nodeId)!;
            delete removed.callbacks;
            Array.from(this.members.values())
                .filter((e) => e.memberId > removed.memberId)
                .filter((e => e.callbacks?.disconnect))
                .forEach((e) => {
                    const disconnectCallback = e.callbacks?.disconnect;
                    if (disconnectCallback) {
                        disconnectCallback({cmd: 'disconnect', node: e.member.node, from: removed.member});
                    }
                });
        }
    }
    addUsers() {
        // do nothing
    }
    removeUsers() {
        // do nothing
    }
    close() {
        // do nothing
    }
}

export function staticDirectory(members: Member[]): Directory {
    const map = new Map<string, MemberInfo>();
    members.forEach((e, idx) => {
        map.set(e.node, {member: {...e}, memberId: idx})
    });
    return new StaticDirectory(map);
}
